import { BeanParameter } from "./BeanParameter";

export class BeanMonitoryParameter{
  constructor(
    public pamoIdCdParametroFormulario: number,
    public moniIdCdMonitoria :number,
    public paraIdCdParametro :number,
    public paraDsValue :string,
    public pamoDhInativo :string,
    public pamoDhRegistro :string,
    public parameter: BeanParameter
  ){}
}
